<homey-page-title title="Manage your notification preferences" class="mb-1"/>

@if (loading() || !preferences()) {
  <div class="space-y-2">
    @for (_ of [0,1,2]; track _) {
      <div class="flex flex-row justify-between items-center py-2">
        <div class="space-y-2 w-full pr-4">
          <p-skeleton height="1rem" width="40%"></p-skeleton>
          <p-skeleton height="0.9rem" width="55%"></p-skeleton>
        </div>
        <p-skeleton height="1.5rem" width="3.5rem" styleClass="flex-shrink-0"></p-skeleton>
      </div>
      <p-divider class="p-0 m-0"/>
    }
  </div>
} @else {
  @if (error(); as errorMessage) {
    <div class="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700 mb-3">
      {{ errorMessage }}
    </div>
  }

  <homey-page-subtitle title="Messages" [subtitle]="messagesSubtitle()"/>
  <homey-notification-category-toggles
    [lotteryEnabled]="preferences()?.categories?.lottery ?? true"
    [lotteryFollowupEnabled]="preferences()?.categories?.lotteryfollowup ?? true"
    [promotionalEnabled]="preferences()?.categories?.promotional ?? false"
    [disabled]="saving()"
    (categoryChange)="onCategoryChange($event)"/>
}
